import styled from 'styled-components';

export const StyledStep = styled.div`
  height: inherit;
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginLG}px;

  .mobile-image-select-body {
    flex-grow: 1;
    height: inherit;
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginSM}px;
    overflow-y: auto;

    .mobile-image-select-title {
      padding-top: ${({ theme: { token } }) => token.paddingSM}px;
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      line-height: ${({ theme: { token } }) => token.lineHeightLG};
    }

    .mobile-image-select-helper-text {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      line-height: ${({ theme: { token } }) => token.lineHeightLG};
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    }

    .mobile-image-select-tag-list {
      overflow-y: auto;
    }

    .mobile-image-select-file-limit {
      color: ${({ theme: { token } }) => token.colorTextDescription};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      line-height: ${({ theme: { token } }) => token.lineHeight};
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    }
  }

  .mobile-image-upload-footer {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${({ theme: { token } }) => token.marginLG}px;

    .mobile-image-select-upload {
      width: 100%;
      padding: 0 ${({ theme: { token } }) => token.paddingXS}px;

      .ant-upload {
        width: inherit;
      }
    }
  }
`;
